<template>
  <table class="variations fffa-results-table">
    <thead>
    <tr>
      <th>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.149 17.261" class="tw-w-4 tw-block tw-mx-auto">
          <path fill="none"
                stroke="#fff"
                d="M9.075 1.13l2.473 5.009 5.527.8-4 3.9.943 5.506-4.944-2.6-4.944 2.6.944-5.506-4-3.9 5.528-.8z"/>
        </svg>
      </th>
      <th>Club</th>
      <th>CF.</th>
      <th>J</th>
      <th>Points</th>
      <th><abbr title="Pénalités">PN.</abbr></th>
      <th>F.</th>
      <th>G</th>
      <th>N</th>
      <th>P</th>
      <th>PTS+</th>
      <th>PTS-</th>
      <th><abbr title="Différence">Diff.</abbr></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="ranking in rankings">
      <td>{{ ranking.position }}</td>
      <td class="tw-border-dashed">
        {{ ranking.club.label }}
        <span v-if="ranking.club.general_forfeit" class="tw-block tw-text-sm tw-text-red">Forfait général</span>
      </td>
      <td class="tw-border-dashed">{{ ranking.cf }}</td>
      <td class="tw-border-dashed">{{ ranking.j }}</td>
      <td class="tw-border-dashed">{{ ranking.points }}</td>
      <td class="tw-border-dashed">{{ ranking.penalties }}</td>
      <td class="tw-border-dashed">{{ ranking.f }}</td>
      <td class="tw-border-dashed">{{ ranking.g }}</td>
      <td class="tw-border-dashed">{{ ranking.n }}</td>
      <td class="tw-border-dashed">{{ ranking.p }}</td>
      <td class="tw-border-dashed">{{ ranking.points_won }}</td>
      <td>{{ ranking.points_loss }}</td>
      <td>{{ ranking.points_diff }}</td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'rankings-table',
  props: {
    rankings: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
